import script from "./InfoFAQ.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoFAQ.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__